const SDD_ERRORS = ['basket.samedayNotAvaialble', 'schedules.unavailable', 'location.not.available'];

const PAYMENT_ERRORS = [
    'payment.paypal.unavailable',
    'payment.applepay.unavailable',
    'payment.klarnaPayment.unavailable',
    'payment.klarnaPayment.notadded',
    'payment.klarnaPayment.notAuthorized',
    'payment.klarnaPayment.unavailable',
    'payment.default.invalid',
    'payment.default.restricted',
    'checkout.zeroorder.tempcard.used'
];

const BOPIS_PICKUP_ERRORS = ['basket.store.not.available', 'bopis.pref.store.empty'];

const SECTION_NAMES = {
    DELIVER_TO: 'Deliver_To',
    SHIPPING_METHOD: 'Shipping_Method',
    PAYMENT: 'Payment',
    BI_BENEFITS: 'Beauty_Insider_Benefits',
    SDD: 'Same-Day_Delivery',
    BOPIS_PICKUP_INFO: 'Pickup_Info',
    GIFT_CARD_DELIVERY: 'gift_card_delivery'
};

const FC_CHECKOUT_SECTIONS = {
    SHIPPING_METHODS: {
        name: 'shippingMethod',
        sectionName: 'Shipping_Method',
        path: 'delivery'
    },
    GIFT_CARD_DELIVERY: {
        name: 'giftCardDeliverTo',
        sectionName: 'gift_card_delivery',
        path: 'giftcardshipping'
    },
    PICKUP_INFO: {
        name: 'pickupInfo',
        sectionName: 'Pickup_Info',
        path: 'pickup'
    },
    PAYMENT: {
        name: 'payment',
        sectionName: 'Payment',
        path: 'payment'
    },
    DELIVER_TO: {
        name: 'deliverTo',
        sectionName: 'Deliver_To',
        path: 'shipping'
    }
};

const FC_CHECKOUT_PATH = '/checkout';
const SHIPPING_ADDRESS_VALIDATION_ERROR = 'shipping_address_validation_error';

const ALTERNATE_PAYMENT_TYPES = {
    PAYPAL: 'paypal',
    VENMO: 'venmo',
    KLARNA: 'klarna',
    AFTERPAY: 'afterpay',
    PAZE: 'paze'
};

const ALTERNATE_PAYMENT_LIST = Object.values(ALTERNATE_PAYMENT_TYPES);

const VENMO_PAYMENT_GROUP = 'VenmoPaymentGroup';

const MAX_CARDS_LIMIT = 7;

const SKU_TYPE = {
    GIFT_CARD: 'Gift Card'
};

export {
    SDD_ERRORS,
    PAYMENT_ERRORS,
    BOPIS_PICKUP_ERRORS,
    SECTION_NAMES,
    FC_CHECKOUT_SECTIONS,
    FC_CHECKOUT_PATH,
    SHIPPING_ADDRESS_VALIDATION_ERROR,
    ALTERNATE_PAYMENT_TYPES,
    ALTERNATE_PAYMENT_LIST,
    VENMO_PAYMENT_GROUP,
    MAX_CARDS_LIMIT,
    SKU_TYPE
};
